<template>
  <el-dialog
    :title="ADJUST_TITLE[dialogType]"
    v-model="visible"
    width="65%"
    :close-on-click-modal="false"
    style="overflow: hidden"
    class="fx"
  >
    <div
      style="overflow-y: auto; height: 45vh; overflow-x: hidden"
      v-loading="loading"
    >
      <el-text type="primary">仓库信息</el-text>
      <el-descriptions
        border
        :column="3"
        v-if="dialogConfig.type == 'detail'"
        class="mt10"
      >
        <el-descriptions-item
          v-for="item in descriptionList"
          :key="item.value"
          :label="item.label"
          :span="item.span || 1"
          width="16%"
        >
          <span class="my_class">{{ formData[item.value] }}</span>
        </el-descriptions-item>
      </el-descriptions>
      <el-form
        :model="formData"
        label-width="100px"
        ref="ruleRef"
        :rules="rules"
        class="mt10"
        v-else
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="仓库编号：" prop="number">
              <el-input
                v-model="formData.number"
                placeholder="请输入编号"
                :maxlength="40"
                v-no-space
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库名称：" prop="name">
              <el-input
                v-model="formData.name"
                v-no-space
                placeholder="请输入名称"
                :maxlength="20"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属组织：" prop="orgId">
              <el-tree-select
                v-model="formData.orgId"
                :data="orgTree"
                placeholder="请选择组织"
                :props="defaultProps"
                :show-checkbox="true"
                :check-strictly="true"
                node-key="organizationCode"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item label="负责人：" prop="headId">
              <el-select
                v-model="formData.headId"
                placeholder="请选择负责人"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :label="item.nikeName"
                  :value="item.userCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仓库地址：" prop="address">
              <el-input
                v-model="formData.address"
                placeholder="请输入地址"
                :maxlength="40"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col>
            <el-form-item label="备注：" prop="remarks">
              <el-input
                type="textarea"
                v-model="formData.remarks"
                :rows="3"
                placeholder="请输入备注"
                show-word-limit
                :maxlength="200"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- <div class="flex mt10">
        <el-text type="primary" v-if="dialogType != 'detail'">总数量： {{ tableData.length }}</el-text>
        <el-button type="primary" v-if="dialogType != 'detail'" @click="handleAddStorageLocation()">新增库存</el-button>
      </div> -->
      <el-text type="primary" v-if="dialogType == 'detail'">库存信息</el-text>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        class="mt10"
        :data="tableData"
        v-if="dialogType == 'detail'"
      >
        <el-table-column label="序号" type="index" width="55" />
        <template v-for="item in columns" :key="item.prop">
          <el-table-column
            v-if="item.show"
            :label="item.label"
            :prop="item.prop"
            :width="item.width || ''"
          >
            <!-- <template #default="{ row }">
              <div class="el-input__wrapper" v-if="dialogType != 'detail'">
                <input v-model.lazy="row[item.prop]" class="el-input__inner" :maxlength="item.maxlength"
                  @blur="validateNameAndNumber(row, item)" />
              </div>
            </template> -->
          </el-table-column>
        </template>
        <!-- <el-table-column label="操作" v-if="dialogType != 'detail'">
          <template #default="{ $index }">
            <el-button type="primary" link @click="handleRemove($index)">移除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        v-if="pages.total > 0"
        :total="pages.total"
        layout="->, prev, pager, next"
        v-model:current-page="pages.page"
        @update:current-page="pagination"
      />
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCancel()">取消</el-button>
        <el-button
          type="primary"
          @click="handleSubmit()"
          :disabled="buttonLoading"
          v-if="dialogType != 'detail'"
        >
          保存
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import { ADJUST_TITLE } from "@/constants";
import {
  queryStashById,
  insertStash,
  updateStash,
  getInventoryInfo,
} from "@/api/stash";
import { queryTableNew } from "@/api/inventory";
import { ElMessage } from "element-plus";
import { queryOrganization } from "@/api/organization";
import { queryPositionTable } from "@/api/position";
import useUserList from "../hooks/useUserList";

const emits = defineEmits(["afterSave"]);

const { userList } = useUserList();

// 弹窗控制
const visible = ref(false);

// 遮罩
const loading = ref(false);

// 表单ref
const ruleRef = ref(null);

// 库位库存按钮
const tableButtons = ref("库存信息");

// 所属组织
const orgTree = ref([]);

// 分页参数
const pages = reactive({
  page: 1,
  total: 0,
});

// 表单数据
const formData = ref({
  number: "",
  name: "",
  orgId: "",
  headId: "",
  address: "",
  remarks: "",
});

// 描述列表
const descriptionList = ref([
  {
    label: "仓库编号",
    value: "number",
  },
  {
    label: "仓库名称",
    value: "name",
  },
  {
    label: "所属组织",
    value: "orgName",
  },
  {
    label: "负责人",
    value: "headIdName",
  },
  {
    label: "仓库地址",
    value: "address",
    span: 2,
  },
  {
    label: "备注",
    value: "remarks",
    span: 3,
  },
]);

// 表单校验规则
const rules = reactive({
  number: [
    { required: true, message: "请输入编号", trigger: "blur" },
    {
      pattern: /^[a-zA-Z0-9]+$/,
      message: "只能输入英文和数字",
      trigger: "blur",
    },
  ],
  name: [{ required: true, message: "请输入仓库名", trigger: "blur" }],
  orgId: [{ required: true, message: "请选择组织", trigger: "change" }],
  headId: [{ required: true, message: "请输入负责人", trigger: "blur" }],
});

// 打开的是新增、编辑、详情
const dialogType = ref("add");

// 参数
const dialogConfig = ref({});

// 表格列配置
const columns = ref([
  {
    label: "库位名称",
    prop: "name",
    show: tableButtons.value === "库位信息",
    maxlength: 20,
  },
  {
    label: "库位编号",
    prop: "number",
    show: tableButtons.value === "库位信息",
    maxlength: 20,
  },
  {
    label: "描述",
    prop: "description",
    width: 300,
    show: tableButtons.value === "库位信息",
    maxlength: 40,
  },
  {
    label: "物料名称",
    prop: "materialDTO.name",
    show: tableButtons.value === "库存信息",
    maxlength: 20,
  },
  {
    label: "物料编号",
    prop: "materialDTO.number",
    show: tableButtons.value === "库存信息",
    maxlength: 20,
  },
  // {
  //   label: "库位",
  //   prop: "warehousePositionName",
  //   show: tableButtons.value === "库存信息",
  //   maxlength: 20,
  // },
  {
    label: "数量",
    prop: "quantity",
    show: tableButtons.value === "库存信息",
    maxlength: 10,
  },
]);

// 表格列
const tableRow = reactive({
  id: null,
  name: null,
  number: null,
  description: null,
});

// 表格数据
const tableData = ref([]);

// 新增按鈕disable
const buttonLoading = ref(false);

// 树形选择props
const defaultProps = reactive({
  label: "organizationName",
});

// 新增编辑函数
const adjustFunc = reactive({
  add: insertStash,
  edit: updateStash,
});

// 弹窗打开的函数
/**
 *
 * @param {*} config
 * config row, type
 */
const handleDialogOpen = (config) => {
  dialogType.value = config.type;
  dialogConfig.value = { ...config };
  tableButtons.value = "库位信息";
  formData.value = {
    number: "",
    name: "",
    orgId: "",
    headId: "",
    address: "",
    remarks: "",
  };
  tableData.value = [];
  ruleRef.value?.resetFields();

  if (config.type != "add") {
    queryDetail(config.row.id);
  }
  getOrgTree();
  visible.value = true;
};

// 新增库位
const handleAddStorageLocation = () => {
  let data = {};
  Object.assign(data, tableRow); // 深拷贝
  tableData.value.push(data);
};

// 移除库位
const handleRemove = (index) => {
  tableData.value.splice(index, 1);
};

// 点击保存
const handleSubmit = () => {
  buttonLoading.value = true;
  ruleRef.value?.validate((valid) => {
    if (valid) {
      let validateRes = tableValidate();
      if (!validateRes) return (buttonLoading.value = false);
      let reqBody = {
        ...formData.value,
        warehousePositionList: tableData.value,
      };
      adjustStash(reqBody);
    } else {
      buttonLoading.value = false;
    }
  });
};

const tableValidate = () => {
  // if (tableData.value.length < 1) {
  //   ElMessage.error("库位不可为空");
  //   return false;
  // }

  // let count = 0;
  // tableData.value.forEach((item) => {
  //   if (!item.name || !item.number) count++;
  // });

  // if (count > 0) {
  //   ElMessage.error("库位名称和编号不能为空");
  //   return false;
  // }
  return true;
};

// 点击取消
const handleCancel = () => {
  ruleRef.value?.resetFields();
  visible.value = false;
};

// 调整（包括新增和编辑）
const adjustStash = (req) => {
  adjustFunc[dialogType.value](req).then((res) => {
    if (res.code == "2000") {
      ElMessage.success("操作成功");
      emits("afterSave");
      visible.value = false;
    }
  });
  setTimeout(() => {
    buttonLoading.value = false;
  }, 300);
};

// 获取详情
const queryDetail = (id) => {
  loading.value = true;
  queryStashById(id)
    .then((res) => {
      const result = res.data;
      const keys = [
        "id",
        "name",
        "number",
        "address",
        "orgName",
        "remarks",
        "headId",
        "headIdName",
      ];
      keys.forEach((key) => {
        formData.value[key] = result[key];
      });
      formData.value.orgId = result.orgId;
      // tableData.value = result.warehousePositionList;
      // pages.total = tableData.value.length;

      gitqueryTableNew(res.data.id);
    })
    .finally(() => {
      loading.value = false;
    });
};
// 获取库存信息
const gitqueryTableNew = (id) => {
  queryTableNew({ page: pages.page, warehouseId: id }).then((res) => {
    pages.total = res.data.total;
    tableData.value = res.data.records;
  });
};

// 页数变化
const pagination = () => {
  // 库存信息
  queryTableNew({
    page: pages.page,
    warehouseId: formData.value.id,
  }).then((res) => {
    pages.total = res.data.total;
    tableData.value = res.data.records;
  });
};

// 获取组织架构
const getOrgTree = () => {
  queryOrganization().then((res) => {
    orgTree.value = res.data || [];
  });
};

// 校验 同一仓库下 需要去重库位名称和库位编号
const validateNameAndNumber = (row, config) => {
  if (config.prop == "description") return;
  const result = tableData.value.find(
    (item) => item[config.prop] === row[config.prop] && item !== row
  );
  if (result) {
    row[config.prop] = "";
    ElMessage.error(`列【${config.label}】的值不可重复`);
  }
};

// 暴露函数给父组件
defineExpose({
  handleDialogOpen,
});
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
}

.mt10 {
  margin-top: 10px;
}

.el-input__wrapper {
  padding-left: 15px;
  padding-right: 15px;

  display: inline-flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  padding: 1px 11px;
  background-color: #ffffff;
  background-image: none;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  box-shadow: 0 0 0 1px #c0c4cc inset;
}

.el-input__inner {
  height: 32px;
  position: relative;
  font-size: 14px;
  display: inline-flex;
  width: 100%;
  line-height: 32px;
  box-sizing: border-box;
  vertical-align: middle;
  text-align: center;
}

.my_class {
  max-width: 100%;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
